import { createShareChat } from '../domain/share/share-chat.js';
import { createSharedInbox } from '../domain/share/shared-inbox.js';

/**
 * share-service.js
 * Orchestrates Shared Prompts actions through domain use cases.
 */
export class ShareService {
  constructor({ gateway, fallbackShare, normaliseRecipient, normaliseInboxItem } = {}) {
    if (!gateway || typeof gateway.shareChat !== 'function') {
      throw new Error('ShareService requires a gateway with shareChat');
    }
    if (typeof gateway.fetchInbox !== 'function') {
      throw new Error('ShareService requires a gateway with fetchInbox');
    }
    if (typeof gateway.saveInboxItem !== 'function') {
      throw new Error('ShareService requires a gateway with saveInboxItem');
    }
    if (typeof gateway.dismissInboxItem !== 'function') {
      throw new Error('ShareService requires a gateway with dismissInboxItem');
    }

    this.gateway = gateway;

    this.shareChatUseCase = createShareChat({
      share: ({ chatId, recipientEmails, includeFull }) =>
        this.gateway.shareChat({ chatId, recipientEmails, includeFull }),
      fallbackShare,
      normaliseRecipient,
    });

    this.inboxUseCase = createSharedInbox({
      fetchInbox: () => this.gateway.fetchInbox(),
      saveInboxItem: (itemId, teamId) => this.gateway.saveInboxItem(itemId, teamId),
      dismissInboxItem: (itemId) => this.gateway.dismissInboxItem(itemId),
      normaliseInboxItem,
    });
  }

  shareChat(chatId, recipientEmails = [], includeFull = false) {
    return this.shareChatUseCase({ chatId, recipientEmails, includeFull });
  }

  fetchInbox() {
    return this.inboxUseCase.fetch();
  }

  saveInboxItem(itemId, teamId) {
    return this.inboxUseCase.save({ itemId, teamId });
  }

  dismissInboxItem(itemId) {
    return this.inboxUseCase.dismiss({ itemId });
  }
}

if (typeof window !== 'undefined') {
  window.AgileProServices = window.AgileProServices || {};
  window.AgileProServices.ShareService = ShareService;
}
